import getStorageKeyPrefix from '@/shared/utils/getStorageKeyPrefix';
import {AnamnesisQuestionsValue} from '../types';

const KEY = `${getStorageKeyPrefix()}_ANAMNESIS_FORM`;

const anamnesisSessionStorage = {
  get(): AnamnesisQuestionsValue | null {
    const value = sessionStorage.getItem(KEY);
    return value ? JSON.parse(value) : null;
  },
  set(value: AnamnesisQuestionsValue) {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  },
  remove() {
    sessionStorage.removeItem(KEY);
  }
};

export default anamnesisSessionStorage;
